import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["g",{"key":"svg-0","strokeWidth":"1.838"}]]

const IconBrandKbin = createReactComponent('outline', 'brand-kbin', 'BrandKbin', __iconNode);

export default IconBrandKbin;